// @flow
interface Storage {
  +length: number;

  clear(): void;

  getItem(key: string): string | null;

  key(index: number): string | null;

  removeItem(key: string): void;

  setItem(key: string, data: string): void;

  // [key: string|number]: any; // we'd need Proxies for that. Unfortunately ONE specific browser does not support Proxies. (Guess which!)
}

interface Logger {
  debug(message: any): void
}

type TempItem = {
  data: string;
  tempLocalStorageItemTouchedAt: number // very specific name to prevent false positives when using the presence of this property to recognize TempItems
}

export default class TempLocalStorage implements Storage {
  logger: Logger
  component: Storage
  timeout: number // timeout in milliseconds

  constructor (component: Storage, timeout: number, logger: Logger) {
    this.logger = logger
    this.component = component
    this.timeout = timeout
  }

  get length (): number {
    return this.component.length
  }

  clear (): void {
    return this.component.clear()
  }

  getItem (key: string): string | null {
    const itemString: string | null = this.component.getItem(key)
    if (itemString === null) {
      return null
    }

    try {
      const item: TempItem = JSON.parse(itemString)
      const age = Date.now() - item.tempLocalStorageItemTouchedAt
      if (age > this.timeout) {
        this.logger.debug('removing expired data')
        this.removeItem(key)

        return null
      } else {
        this.logger.debug('retrieved unexpired data. Saving again, to update the TouchedAt timestamp')
        this.setItem(key, item.data)
      }
      return item.data
    } catch (e) {
      this.logger.debug('returning unchanged itemString')
      return itemString // if it's not json, it's not a TempItem
    }
  }

  key (index: number): string | null {
    return this.component.key(index)
  }

  removeItem (key: string): void {
    this.component.removeItem(key)
  }

  setItem (key: string, data: string): void {
    const tempItem = {
      data: data,
      tempLocalStorageItemTouchedAt: Date.now()
    }
    this.component.setItem(key, JSON.stringify(tempItem))
  }
}



// WEBPACK FOOTER //
// ./src/temp-local-storage/index.js